<template>
  <v-container class="fill-height pb-0" >
    <v-card class="e-cardLeccion-intro e-elevation--4 e-border--radius fill-height">
      <v-card-text class="e-cardLeccion-intro-title py-2 justify-start d-flex-column">
        <p class="e-description-small mb-0 text-xs-left ">{{ tema }}</p>
        <p class="e-sub-sub-title mb-0 text-xs-left">{{ subtema }}</p>
      </v-card-text>
      <v-card-text class="e-cardLeccion-intro-text px-4 align-start" v-html="descripcionKr">
          <!--p class="e-description-middle mb-0 text-xs-center pt-3 pb-3" v-html="descripcionKr"></p-->
          <!--p class="p-normal mb-0 text-xs-left pb-2 pt-3" v-html="descripcionEs"></p-->
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'LeccionEjemplo',
  props: {
    tema: {
      type: String,
      default: ''
    },
    subtema: {
      type: String,
      default: ''
    },
    descripcionKr: {
      type: String,
      default: ''
    },
    descripcionEs: {
      type: String,
      default: ''
    }
  }
}
</script>
